import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BotFlow, GlobalStorage } from '@feedyou-ai/feedbot-schema'

export const initialState: BotFlow = {} as any

const slice = createSlice({
  name: 'flow',
  initialState,
  reducers: {
    setFlow: (state, action: PayloadAction<BotFlow>) => {
      return action.payload
    },

    editGlobalStorage: (
      state,
      action: PayloadAction<{ prevName: string | undefined; newStorage: GlobalStorage }>
    ) => {
      const { prevName, newStorage } = action.payload

      if (!state.globalStorages) {
        state.globalStorages = {}
      }

      if (typeof prevName === 'string') {
        delete state.globalStorages[prevName]
      }

      state.globalStorages[newStorage.name] = newStorage
    }
  }
})

export const reducer = slice.reducer
export const actions = slice.actions
